import { Toast, useToastManager } from "@norican/react";

import { useT } from "@/i18n";

/**
 * Renders the toast stack.
 *
 * The design system deliberately does not render the list for you — the
 * manager owns the queue, the app owns the markup. Mounted once, inside
 * `Toast.Provider`, by `AppProviders`. Feature code never renders this; it
 * calls `useToastManager().add()` / `.promise()`.
 */
export function Toaster() {
  const { t } = useT();
  const { toasts } = useToastManager();

  return (
    <Toast.Portal>
      <Toast.Viewport position="bottom-right">
        {toasts.map((toast) => (
          <Toast.Root key={toast.id} toast={toast}>
            <Toast.Content>
              <Toast.Title />
              <Toast.Description />
            </Toast.Content>
            <Toast.CloseButton label={t("a11y.dismiss")} />
          </Toast.Root>
        ))}
      </Toast.Viewport>
    </Toast.Portal>
  );
}
